import {
  applyBrandColors,
  applyBrandContrastVars
} from '~/ui/buttons/helpers/getContrastingColor';

/**
 * Recompute on-accent / focus / link tokens from the current --color-accent-dk
 * when the learner surface flips between light and dark.
 */
export const refreshBrandContrastForSurface = (
  surfaceIsDark: boolean,
  element: HTMLElement = document.documentElement
): void => {
  const accent = getComputedStyle(element)
    .getPropertyValue('--color-accent-dk')
    .trim();
  applyBrandContrastVars(element.style, accent, surfaceIsDark);
};

export { applyBrandColors };
